module.exports = "<div [class]=\"animationShapeRight ? 'animationnew-shap' : 'animation-shap'\">\n  <div class=\"shap-bg\"></div>\n</div>\n"